// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8":"f72f0573ca758ab96030","126":"1daa380cf3b967cb2dbd"}[chunkId] + ".js";
};